export var getRenderListData = (showFullList, showExpandCta, data, initialItemCount) => {
  return showFullList || !showExpandCta ? data : data.slice(0, Math.min(data.length, initialItemCount));
};
export var getSelectedPlan = (planDetailsList, selectedPack) => {
  var selectedPlanDetails = planDetailsList === null || planDetailsList === void 0 ? void 0 : planDetailsList.filter(item => (item === null || item === void 0 ? void 0 : item.value) == selectedPack);
  return selectedPlanDetails === null || selectedPlanDetails === void 0 ? void 0 : selectedPlanDetails[0];
};